import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";

const newStore = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});

export default newStore;
